export default __webpack_public_path__ + "static/media/menuWhite.f9206bee.svg";